<template>
    <v-app>
        <router-view/>
      <notifications/>
    </v-app>
</template>

<script>
    export default {}
</script>